import { useEffect, useRef, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SubPageHeader from '@/components/layout/SubPageHeader';
import SubPageShell from '@/components/layout/SubPageShell';
import SubPageSection from '@/components/layout/SubPageSection';
import SubPageSurface from '@/components/layout/SubPageSurface';
import SectionHeading from '@/components/base/SectionHeading';
import { SUBPAGE_SURFACE_BORDER } from '@/constants/surfaceColors';
import AboutSection from '@/pages/home/components/AboutSection';
import ServiceSection from '@/pages/home/components/ServiceSection';

const companyData = [
  { label: '会社名', value: '株式会社キャデック' },
  { label: '英文社名', value: 'Computer Added Development & Engineering Co.,ltd.' },
  { label: '所在地', value: '〒039-1114 青森県八戸市北白山台5丁目2-5\n東奥日報社八戸ビル5階' },
  { label: '代表取締役', value: '増尾孝司' },
  { label: '創立年月日', value: '平成3年5月18日' },
  { label: '資本金', value: '2,400万円' },
  { label: '建築士事務所登録', value: '一級建築士事務所 青森県知事登録 第844号' },
  { label: '管理建築士', value: '増尾孝司' },
  { label: 'TEL', value: '0178-51-8296' },
  { label: 'FAX', value: '0178-51-8297' },
  { label: 'E-mail', value: 'cadec@cadec.co.jp' },
  { label: '従業員数', value: '6名（就業場所全体7名）' },
  { label: '業務内容', value: '建築物の調査・企画・設計・積算・工事監理\n（新築・増改築・改修・耐震関係・用途変更 他）\n建築物の法定点検、定期調査報告' },
  { label: '主な用途', value: '公共施設全般・福祉施設・物流施設・工場・事務所・店舗 他' },
  { label: '主な構造', value: '鉄筋コンクリート造、鉄骨造、木造 他' },
];

function FadeIn({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className="transition-all duration-700"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(24px)',
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

export default function CompanyPage() {
  return (
    <SubPageShell>
      <Navbar />

      <SubPageHeader>
          <SectionHeading label="COMPANY" title="会社情報" as="h1" tone="dark" size="page" />
      </SubPageHeader>

      <AboutSection showProfileLink={false} />

      <ServiceSection />

      {/* Company Profile Table */}
      <SubPageSection>
          <FadeIn>
            <SectionHeading label="PROFILE" title="会社概要" tone="dark" className="mb-14" />
          </FadeIn>

          <FadeIn delay={100}>
            <SubPageSurface>
              {companyData.map((row, i) => (
                <div
                  key={row.label}
                  className="grid grid-cols-1 sm:grid-cols-4 gap-0"
                  style={{ borderBottom: i < companyData.length - 1 ? `1px solid ${SUBPAGE_SURFACE_BORDER}` : 'none' }}
                >
                  <div
                    className="sm:col-span-1 px-6 py-5 flex items-start"
                    style={{ background: 'rgba(45,45,44,0.98)' }}
                  >
                    <span
                      style={{ fontSize: '16px', color: '#FFFFFF', fontFamily: '"Noto Sans JP", sans-serif', letterSpacing: '0.05em', paddingTop: '1px' }}
                    >
                      {row.label}
                    </span>
                  </div>
                  <div
                    className="sm:col-span-3 px-6 py-5"
                  >
                    <span
                      style={{ fontSize: '16px', color: '#1A1A1A', fontFamily: '"Noto Sans JP", sans-serif', lineHeight: '1.9', whiteSpace: 'pre-line' }}
                    >
                      {row.value}
                    </span>
                  </div>
                </div>
              ))}
            </SubPageSurface>
          </FadeIn>
      </SubPageSection>

      <Footer />
    </SubPageShell>
  );
}
